module.exports = __webpack_public_path__ + "img/permissions-error-blob.576c265a.svg";